<template>
  <v-container fill-height class="py-16">
    <v-row justify="center" class="col-12">
      <v-img aria-label="Dark Wolf Solutions, LLC"
        src="../../assets/head_logo.png"
        alt="Dark Wolf"
        height="25vh"
        contain></v-img>
    </v-row>
    <v-row no-gutters justify="center" class="col-12">
      <h1 class="display-3 dw_green--text font-weight-thin">Pentesting Playbook</h1>
    </v-row>
    <v-row justify="center" class="col-12 pt-10">
      <v-progress-circular
        :size="70"
        :width="4"
        color="dw_green"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'pageLoading'
};
</script>
